<script>
    import {drops, cleanAddress, state, onTransactionConfirm} from "../stores/contracts";
    import {drops as drops_infura, useInfura, state_infura} from "../stores/contracts-infura";

    import DropListing from "../components/DropListing.svelte";
    import Spinner from "../components/Spinner.svelte";
    import Window from "../components/Window.svelte";


    // export let currentRoute;

    export let tokenAddress;
    export let dropTokenId;
    export let toFront = () => {
    };
    export let minimise = ()=>{}
    export let depth;
    export let active;


    // if (currentRoute.namedParams.dropTokenAddress) {
    //     tokenAddress = cleanAddress(currentRoute.namedParams.dropTokenAddress);
    // }
    // if (currentRoute.namedParams.dropTokenId) {
    //     dropTokenId = parseInt(currentRoute.namedParams.dropTokenId);
    // }

    let drop, _state;
    $:{
        let _drops;
        if ($useInfura) {
            _state = $state_infura;
            _drops = $drops_infura;
        } else {
            _state = $state;
            _drops = $drops;
        }

        if (
            _drops[tokenAddress] &&
            _drops[tokenAddress][dropTokenId]
        ) {
            drop = {
                tokenAddress,
                dropTokenId,
                atomicNumber: _drops[tokenAddress][dropTokenId].atomicNumber,
                ionCharge: _drops[tokenAddress][dropTokenId].ionCharge,
                isIon: _drops[tokenAddress][dropTokenId].isIon,
                tokenId: _drops[tokenAddress][dropTokenId].tokenId,
                blockNumber: _drops[tokenAddress][dropTokenId].blockNumber,
                probability: _drops[tokenAddress][dropTokenId].probability
            }
        }
    }


    onTransactionConfirm((func, params) => {
        if (func !== "claimDrop") return;
        alert("NFT successfully claimed!")
        minimise("drop");
    });
</script>

<!--<style>-->
<!--    .section-drop{-->
<!--        display: flex;-->
<!--        flex-direction: column;-->
<!--    }-->
<!--</style>-->

<style>

    .section-loading{
        font-size: 30px;
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .section-loading div{
        padding-top: 50px;
    }
    .error{
        color: darkred;
    }

    .not-found{
        color: darkred;
    }

    .section-listing{
        width:100%;
        min-width: 810px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>

<Window depth={depth} toFront={toFront} active={active} name="DROP" minimise={minimise}>

    {#if _state !== "loaded"}
        {#if _state === "network"}
            <div class="section-loading error">
                <div>Please connect to Ethereum mainnet.</div>
            </div>
        {:else if _state === "error"}
            <div class="section-loading  error">
                <div >Web3 connection error.</div>
            </div>
        {:else }
            <div class="section-loading">
                <div >Loading data...</div>
            </div>
        {/if}
    {:else }
        {#if drop}
            <div class="section-listing">
                <DropListing drop={drop} singlePage={true}/>
            </div>
        {:else }
            <div class="section-loading not-found">
                <div >Drop not found.</div>
                <!--            <Spinner size="80"/>-->
            </div>
        {/if}
    {/if}
</Window>